import { createAction, props } from '@ngrx/store';

export const setCartCustomerOrdersExpanded = createAction(
  '[Cart] Set Cart Customer Orders Expanded',
  props<{ expanded: boolean }>(),
);
